class BuildABox {
  constructor() {
    this.state = {
      step: 1,
      gender: "female",
      selectedBox: null,
      selectedCase: null,
      selectedScents: [],
      total: 0,
      scentLimit: 3,
      additionalSlotEnabled: false,
      fifthSlotEnabled: false,
      hasShownFifthPopup: false,
      selling_plan_id: "692079100250",
      purchaseType: "subscribe",
      // selling_plan_id: null,
      // purchaseType: "onetime"
    };

    this.products = productsData;
    console.log("this.products", this.products);

    // ===== EDIT MODE (Perfect Scent box editor) =====
    // If the URL has ?sub=ID&token=HASH we are editing an existing subscription
    // instead of building a new box for checkout.
    this.PS_ENDPOINT = "https://snow-owl-642309.hostingersite.com/ps-box-update.php";
    const psParams = new URLSearchParams(window.location.search);
    this.editMode = !!(psParams.get("sub") && psParams.get("token"));
    this.editSub = psParams.get("sub");
    this.editToken = psParams.get("token");
    // In edit mode, start directly on the scents step so step 1/2 never flash.
    if (this.editMode) this.state.step = 3;
    // ================================================

    // DOM elements
    this.genderSelects = document.querySelectorAll(".gender-select");
    this.boxProducts = document.getElementById("box-products");
    this.caseProducts = document.getElementById("case-products");
    this.scentProducts = document.getElementById("scent-products");
    this.summaryContent = document.getElementById("summary-content");
    this.nextStepBtn = document.getElementById("next-step");
    this.goBackBtn = document.getElementById("go-back");
    this.steps = document.querySelectorAll(".main-content .steps .step");
    this.indicators = document.querySelectorAll(".indicator");

    // Track if initial render is complete
    this.isInitialRenderDone = false;

    // Bind events
    this.bindEvents();

    // Pre-render all steps for smooth transitions
    this.initialRender();

    // In edit mode, open straight on the scents step (box + case come in a
    // pouch and aren't changed here). The step bar is hidden in the liquid.
    if (this.editMode) {
      this.state.step = 3;
      if (this.goBackBtn) this.goBackBtn.style.display = "none";
      this.render();
      this.loadExistingSelection();
    }
  }

  // ===== EDIT MODE: load current subscription selection and prefill =====
  loadExistingSelection(attempt = 1) {
    const btn = this.nextStepBtn;
    fetch(`${this.PS_ENDPOINT}?sub=${encodeURIComponent(this.editSub)}&token=${encodeURIComponent(this.editToken)}`)
      .then((r) => {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then((d) => {
        if (!d.ok) {
          alert(d.error || "Could not load your box. This edit link may be invalid.");
          return;
        }
        const p = d.properties || {};

        // store next delivery date for the confirmation screen
        if (d.next_charge) {
          const dt = new Date(d.next_charge);
          if (!isNaN(dt)) {
            this._nextCharge = dt.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
          }
        }

        // Prefill BOX by matching name across both genders' boxes
        const boxName = p["box name"];
        const caseName = p["case name"];
        if (boxName) {
          const allBoxes = [].concat(this.products.boxes?.female || [], this.products.boxes?.male || []);
          const found = allBoxes.find((b) => b.name === boxName);
          if (found) this.state.selectedBox = found;
        }
        if (caseName) {
          const allCases = [].concat(this.products.cases?.female || [], this.products.cases?.male || []);
          const found = allCases.find((c) => c.name === caseName);
          if (found) this.state.selectedCase = found;
        }

        // Prefill SCENTS (properties look like "Scent 1" = "Name × 2")
        const allScents = [].concat(this.products.scents?.female || [], this.products.scents?.male || []);
        const picked = [];
        for (let i = 1; i <= 5; i++) {
          const v = p["Scent " + i];
          if (!v) continue;
          const m = String(v).match(/^(.*?)\s*×\s*(\d+)\s*$/);
          const name = m ? m[1].trim() : String(v).trim();
          const qty = m ? parseInt(m[2], 10) : 1;
          const prod = allScents.find((s) => s.name === name);
          if (prod) picked.push(Object.assign({}, prod, { quantity: qty }));
        }
        if (picked.length) this.state.selectedScents = picked;

        // Slots (kept for context / save payload accuracy)
        if (p["Extra Slot Added"] === "Yes") { this.state.additionalSlotEnabled = true; }
        if (p["5th Slot Added"] === "Yes") { this.state.fifthSlotEnabled = true; }

        // COUNT-LOCK: in edit mode the customer keeps the exact same number of
        // scents they already have (they can only swap, not add/remove). This
        // keeps their plan and price identical (Patrick's safe option).
        const lockedCount = picked.reduce((t, s) => t + (s.quantity || 1), 0);
        this.editLockedCount = lockedCount > 0 ? lockedCount : 3;
        this.state.scentLimit = this.editLockedCount;

        // Open straight on the scents step (box + case come in a pouch).
        this.state.step = 3;

        // Re-render to reflect prefilled selection
        this.renderBoxes();
        this.renderCases();
        this.renderScents();
        this.render();
      })
      .catch(() => {
        // Transient failure (network blip / cold start): retry once quietly.
        if (attempt < 2) {
          setTimeout(() => this.loadExistingSelection(attempt + 1), 900);
        } else {
          alert("We couldn't load your box just now. Please refresh the page and try again.");
        }
      });
  }

  // ===== EDIT MODE: save updated selection to the subscription =====
  saveBox() {
    if (!this.state.selectedBox || !this.state.selectedCase || this.state.selectedScents.length === 0) {
      alert("Please select a box, case, and at least one scent.");
      return;
    }
    const minRequired = this.state.scentLimit;
    const scentCount = this.getTotalScentsCount();
    if (scentCount < minRequired) { alert(`Please select at least ${minRequired} scents.`); return; }

    this.nextStepBtn.disabled = true;
    this.nextStepBtn.textContent = "SAVING...";

    const scents = [];
    this.state.selectedScents.forEach((s) => {
      for (let q = 0; q < (s.quantity || 1); q++) scents.push(s.name);
    });

    const payload = {
      sub: this.editSub,
      token: this.editToken,
      selection: {
        box_name: this.state.selectedBox.name,
        case_name: this.state.selectedCase.name,
        scents: scents,
        extra_slot: this.state.additionalSlotEnabled,
        fifth_slot: this.state.fifthSlotEnabled,
      },
    };

    fetch(this.PS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok) {
          const wrap = document.querySelector(".build-a-box") || document.body;
          wrap.innerHTML =
            '<div style="max-width:560px;margin:0 auto;text-align:center;padding:70px 24px;font-family:\'Helvetica Neue\',Arial,sans-serif;">' +
              '<div style="width:84px;height:84px;border-radius:50%;background:#54c63a;color:#fff;font-size:44px;display:flex;align-items:center;justify-content:center;margin:0 auto 24px;box-shadow:0 8px 30px rgba(84,198,58,.3);">✓</div>' +
              '<h2 style="font-weight:700;font-size:26px;margin:0 0 10px;color:#242424;">Your box is updated!</h2>' +
              '<p style="color:#666;font-size:16px;line-height:1.5;margin:0 0 8px;">Your new scent selection has been saved and will ship with your next delivery.</p>' +
              (this._nextCharge ? '<p style="color:#242424;font-size:15px;margin:0 0 28px;">Next delivery: <strong>' + this._nextCharge + '</strong></p>' : '<div style="height:20px;"></div>') +
              '<a href="https://perfectscent4u.com" style="display:inline-block;background:#242424;color:#fff;text-decoration:none;padding:14px 34px;border-radius:4px;font-weight:600;font-size:15px;">Back to Perfect Scent</a>' +
              '<p style="color:#aaa;font-size:13px;margin-top:24px;">You can safely close this page.</p>' +
            '</div>';
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          alert(d.error || "Could not save. Please try again.");
          this.nextStepBtn.disabled = false;
          this.nextStepBtn.textContent = "SAVE MY BOX";
        }
      })
      .catch(() => {
        alert("Network error. Please try again.");
        this.nextStepBtn.disabled = false;
        this.nextStepBtn.textContent = "SAVE MY BOX";
      });
  }

  // Pre-render all steps on page load for smooth slider experience
  initialRender() {
    // Render all product containers immediately
    this.renderBoxes();
    this.renderCases();
    this.renderScents();

    // Mark initial render as complete
    this.isInitialRenderDone = true;

    // Now do the normal render for UI state
    this.render();
  }

  bindEvents() {
    this.genderSelects.forEach((select) => {
      select.addEventListener("change", (e) => {
        const newGender = e.target.value;
        const previousGender = this.state.gender;
        this.state.gender = newGender;
        this.genderSelects.forEach((s) => {
          s.value = newGender;
        });

        // If gender changed, we need to re-render all products
        if (previousGender !== newGender) {
          this.renderBoxes();
          this.renderCases();
          this.renderScents();
        }

        this.render();
      });
    });

    this.nextStepBtn.addEventListener("click", () => {
      if (this.state.step === 1) {
        this.state.step = 2;
        this.render();
      } else if (this.state.step === 2) {
        this.state.step = 3;
        this.render();
      } else {
        if (this.editMode) {
          this.saveBox();
        } else {
          this.addToCart();
        }
      }
    });

    this.goBackBtn.addEventListener("click", () => {
      if (this.state.step === 2) {
        this.state.step = 1;
        this.render();
      } else if (this.state.step === 3) {
        this.state.step = 2;
        this.render();
      }
    });
  }

  getTotalScentsCount() {
    return this.state.selectedScents.reduce(
      (total, scent) => total + scent.quantity,
      0,
    );
  }

  getCurrentScentLimit() {
    // In edit mode the max is locked to the subscription's current scent count.
    if (this.editMode && this.editLockedCount) {
      return this.editLockedCount;
    }
    if (this.state.fifthSlotEnabled) {
      return this.state.scentLimit + 2; // 3 + 2 = 5 scents
    } else if (this.state.additionalSlotEnabled) {
      return this.state.scentLimit + 1; // 3 + 1 = 4 scents
    } else {
      return this.state.scentLimit; // 3 scents
    }
  }

  calculateTotal() {
    const currentScentCount = this.getTotalScentsCount();
    if (this.state.fifthSlotEnabled && currentScentCount >= 5) {
      // For now, use the 4th scent product price as placeholder
      // You can update this later with actual 5th scent product pricing
      return this.products.product_with_additional.price + 1.0; // Add €1.00 for 5th scent
    } else if (this.state.additionalSlotEnabled && currentScentCount >= 4) {
      return this.products.product_with_additional.price;
    } else {
      return this.products.product_without_additional.price;
    }
  }

  render() {
    // Update step indicators
    this.steps.forEach((step, index) => {
      step.classList.toggle("active", index + 1 === this.state.step);
    });

    this.indicators.forEach((indicator, index) => {
      const isActive =
        index + 1 === this.state.step ||
        (index === 0 && this.state.selectedBox) ||
        (index === 1 && this.state.selectedCase);
      indicator.classList.toggle("active", isActive);
    });

    this.goBackBtn.style.display =
      (!this.editMode && this.state.step > 1) ? "block" : "none";

    // Update indicator classes for progress bar (guarded: the bar is removed
    // from the editor page, so these may not exist)
    const ind1 = document.querySelector("#indicator-1");
    const ind2 = document.querySelector("#indicator-2");
    const ind3 = document.querySelector("#indicator-3");
    if (ind1 && ind2 && ind3) {
      if (this.state.step === 1) {
        ind1.classList.add("c-active");
        ind2.classList.remove("c-active");
        ind3.classList.remove("c-active");
      } else if (this.state.step === 2) {
        ind2.classList.add("c-active");
        ind1.classList.remove("c-active");
        ind3.classList.remove("c-active");
      } else {
        ind3.classList.add("c-active");
        ind2.classList.remove("c-active");
        ind1.classList.remove("c-active");
      }
    }

    // Only re-render products if needed (gender change or selection update)
    // After initial render, we update selections in place rather than re-rendering
    if (this.isInitialRenderDone) {
      this.updateBoxSelections();
      this.updateCaseSelections();
      this.updateScentSelections();
    }

    this.renderSummary();
    this.updateButtonState();
  }

  // Update box selection states without re-rendering
  updateBoxSelections() {
    if (!this.boxProducts) return;

    const boxes = this.products.boxes[this.state.gender] || [];
    const cards = this.boxProducts.querySelectorAll(".product-card");

    cards.forEach((card, index) => {
      if (index < boxes.length) {
        const product = boxes[index];
        const isSelected =
          this.state.selectedBox && this.state.selectedBox.id === product.id;
        card.classList.toggle("selected", isSelected);
        card.classList.toggle(
          "disabled",
          this.state.selectedBox && !isSelected,
        );
      }
    });
  }

  // Update case selection states without re-rendering
  updateCaseSelections() {
    if (!this.caseProducts) return;

    const cases = this.products.cases[this.state.gender] || [];
    const cards = this.caseProducts.querySelectorAll(".product-card");

    cards.forEach((card, index) => {
      if (index < cases.length) {
        const product = cases[index];
        const isSelected =
          this.state.selectedCase && this.state.selectedCase.id === product.id;
        card.classList.toggle("selected", isSelected);
        card.classList.toggle(
          "disabled",
          this.state.selectedCase && !isSelected,
        );

        // Update button text
        const button = card.querySelector(".btn_wrapper button");
        if (button) {
          button.textContent = isSelected
            ? this.products.uiText?.removeButton || "REMOVE"
            : this.products.uiText?.addToBoxButton || "ADD TO BOX";
          button.classList.toggle("remove-btn", isSelected);
          button.disabled = this.state.selectedCase && !isSelected;
        }
      }
    });
  }

  // Update scent selection states without re-rendering
  updateScentSelections() {
    if (!this.scentProducts) return;

    const scents = this.products.scents[this.state.gender] || [];
    const currentLimit = this.getCurrentScentLimit();

    // Check if we need to show additional popup (4th scent)
    const scentsCount = this.getTotalScentsCount();
    if (
      scentsCount === this.state.scentLimit &&
      !this.state.additionalSlotEnabled &&
      !this.hasShownAdditionalPopup
    ) {
      this.hasShownAdditionalPopup = true;
      setTimeout(() => {
        this.showAdditionalSlotPopup();
      }, 100);
    }

    // Check if we need to show 5th scent popup
    if (
      scentsCount === 4 &&
      this.state.additionalSlotEnabled &&
      !this.state.fifthSlotEnabled &&
      !this.hasShownFifthPopup
    ) {
      this.hasShownFifthPopup = true;
      setTimeout(() => {
        this.showFifthScentPopup();
      }, 100);
    }

    const cards = this.scentProducts.querySelectorAll(".product-card");

    cards.forEach((card, index) => {
      if (index < scents.length) {
        const product = scents[index];
        const selectedScent = this.state.selectedScents.find(
          (s) => s.id === product.id,
        );
        const isDisabled =
          !selectedScent && this.getTotalScentsCount() >= currentLimit;

        card.classList.toggle("selected", !!selectedScent);
        card.classList.toggle("disabled", isDisabled);

        // Update quantity display or button
        const btnWrapper = card.querySelector(".btn_wrapper");
        if (btnWrapper) {
          if (selectedScent) {
            btnWrapper.innerHTML = `
              <div class="quantity-controls">
                <button class="decrease">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.3334 8.37695H2.66675" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <span>${selectedScent.quantity}</span>
                <button class="increase">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00008 3.04395V13.7106M13.3334 8.37728L2.66675 8.37728" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            `;
            this.bindScentQuantityControls(card, product, selectedScent);
          } else {
            btnWrapper.innerHTML = `<button>${this.products.uiText?.addToBoxButton || "ADD TO BOX"}</button>`;
            const button = btnWrapper.querySelector("button");
            button.disabled = isDisabled;
            this.bindScentAddButton(button, product, currentLimit);
          }
        }
      }
    });
  }

  // Bind scent quantity control events
  bindScentQuantityControls(card, product, selectedScent) {
    const decreaseBtn = card.querySelector(".decrease");
    const increaseBtn = card.querySelector(".increase");

    if (decreaseBtn) {
      decreaseBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        selectedScent.quantity--;

        if (selectedScent.quantity === 0) {
          this.state.selectedScents = this.state.selectedScents.filter(
            (s) => s.id !== product.id,
          );

          // Reset additional slot if below 3 scents
          if (
            this.state.additionalSlotEnabled &&
            this.getTotalScentsCount() < this.state.scentLimit
          ) {
            this.hasShownAdditionalPopup = false;
            this.state.additionalSlotEnabled = false;
          }

          // Reset fifth slot if below 4 scents
          if (this.state.fifthSlotEnabled && this.getTotalScentsCount() < 4) {
            this.hasShownFifthPopup = false;
            this.state.fifthSlotEnabled = false;
          }
        }

        this.state.total = this.calculateTotal();
        this.render();
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener("click", (e) => {
        e.stopPropagation();

        const currentCount = this.getTotalScentsCount();
        const currentLimit = this.getCurrentScentLimit();

        if (currentCount >= currentLimit) {
          alert(
            this.products.uiText?.scentLimitMessage ||
              "You've reached the scent limit. Remove a scent to add another.",
          );
          return;
        }

        selectedScent.quantity++;
        this.state.total = this.calculateTotal();
        this.render();

        if (this.getTotalScentsCount() === currentLimit) {
          setTimeout(() => this.scrollToCheckout(), 300);
        }
      });
    }
  }

  // Bind scent add button event
  bindScentAddButton(button, product, currentLimit) {
    button.addEventListener("click", (e) => {
      e.stopPropagation();

      if (this.getTotalScentsCount() >= currentLimit) {
        alert(
          this.products.uiText?.scentLimitMessage ||
            "You've reached the scent limit. Remove a scent to add another.",
        );
        return;
      }

      this.state.selectedScents.push({
        ...product,
        quantity: 1,
        productGender: this.state.gender,
      });

      this.state.total = this.calculateTotal();
      this.render();

      if (this.getTotalScentsCount() === currentLimit) {
        setTimeout(() => this.scrollToCheckout(), 300);
      }
    });
  }

  updateButtonState() {
    if (this.state.step === 1) {
      this.nextStepBtn.disabled = !this.state.selectedBox;
      this.nextStepBtn.textContent =
        this.products.uiText?.nextStepButton || "NEXT STEP";
    } else if (this.state.step === 2) {
      this.nextStepBtn.disabled = !this.state.selectedCase;
      this.nextStepBtn.textContent =
        this.products.uiText?.nextStepButton || "NEXT STEP";
    } else {
      // For step 3, check if the required number of scents are selected
      const scentCount = this.getTotalScentsCount();
      const requiredCount = this.getCurrentScentLimit();
      this.nextStepBtn.disabled =
        scentCount < this.state.scentLimit || scentCount > requiredCount;
      this.nextStepBtn.textContent = this.editMode
        ? "SAVE MY BOX"
        : (this.products.uiText?.checkoutButton || "CHECK OUT");
    }
  }

  renderBoxes() {
    if (!this.boxProducts) return;

    this.boxProducts.innerHTML = "";
    const boxes = this.products.boxes[this.state.gender] || [];

    if (boxes.length === 0) {
      this.boxProducts.innerHTML = `<p>${
        this.products.uiText?.noBoxesMessage || "No boxes available."
      }</p>`;
      return;
    }

    boxes.forEach((product) => {
      const isSelected =
        this.state.selectedBox && this.state.selectedBox.id === product.id;
      const hasOriginalPrice =
        product.originalPrice && product.originalPrice > product.price;
      const savings = hasOriginalPrice
        ? (product.originalPrice - product.price).toFixed(2)
        : null;

      const card = document.createElement("div");
      card.className = `product-card ${isSelected ? "selected" : ""} ${
        this.state.selectedBox && !isSelected ? "disabled" : ""
      } ${
        product.Stock > 10
          ? "in_stock"
          : product.Stock > 0
            ? "low_stock"
            : product.Stock == "In stock"
              ? ""
              : "out_of_stock"
      }`;

      card.innerHTML = `
        <img src="${product.image || "placeholder.jpg"}" alt="${
          product.name || "Unknown Product"
        }" loading="eager">
        <div class="card-info">
          <p class="name">${product.name || "Unknown Product"}</p>
          <p class="stock">Only ${product.Stock} left in Stock</p>
          <p class="no_stock">Out of Stock</p>
          <div class="desc-container">
            <p class="desc">${
              product?.description
                ? product.description.split(" ").slice(0, 10).join(" ") + "..."
                : ""
            }<span class="read_more">Readmore</span></p>
             <p class="desc read-more-desc">${
               product?.description
             } <span class="read_less">Read less</span></p>
          </div>
        </div>
      `;

      // Allow clicking a card when nothing is selected, or when this card is
      // the selected one (to deselect). After deselecting, all cards become
      // clickable again on the next render.
      const clickable = !this.state.selectedBox || isSelected;
      if (clickable) {
        card.classList.add("clickable");
        const onClick = () => {
          if (this.state.selectedBox && this.state.selectedBox.id === product.id) {
            // deselect
            this.state.selectedBox = null;
            this.state.total = this.calculateTotal();
            this.renderBoxes();
            this.render();
          } else {
            // select
            this.state.selectedBox = {
              ...product,
              quantity: 1,
              productGender: this.state.gender,
            };
            this.state.total = this.calculateTotal();
            setTimeout(() => {
              if (this.state.selectedBox) {
                this.state.step = 2;
              }
              this.render();
            }, 300);
            this.render();
          }
        };
        card.addEventListener("click", onClick);
      }

      this.boxProducts.appendChild(card);
    });
  }

  renderCases() {
    if (!this.caseProducts) return;

    this.caseProducts.innerHTML = "";
    const cases = this.products.cases[this.state.gender] || [];

    if (cases.length === 0) {
      this.caseProducts.innerHTML = `<p>${
        this.products.uiText?.noCasesMessage || "No cases available."
      }</p>`;
      return;
    }

    cases.forEach((product) => {
      const isSelected =
        this.state.selectedCase && this.state.selectedCase.id === product.id;
      const hasOriginalPrice =
        product.originalPrice && product.originalPrice > product.price;
      const savings = hasOriginalPrice
        ? (product.originalPrice - product.price).toFixed(2)
        : null;

      const card = document.createElement("div");
      card.className = `product-card ${isSelected ? "selected" : ""} ${
        this.state.selectedCase && !isSelected ? "disabled" : ""
      } ${
        product.Stock > 10
          ? "in_stock"
          : product.Stock > 0
            ? "low_stock"
            : product.Stock == "In stock"
              ? ""
              : "out_of_stock"
      }`;

      card.innerHTML = `
        <img src="${product.image || "placeholder.jpg"}" alt="${
          product.name || "Unknown Product"
        }" loading="eager">
        <div class="card-info">
          <p class="name">${product.name || "Unknown Product"}</p>
          <p class="stock">Only ${product.Stock} left in Stock</p>
          <p class="no_stock">Out of Stock</p>
          <div class="btn_wrapper">
          ${
            isSelected
              ? `<button class="remove-btn">${
                  this.products.uiText?.removeButton || "REMOVE"
                }</button>`
              : `<button>${
                  this.products.uiText?.addToBoxButton || "ADD TO BOX"
                }</button>`
          }
          </div>
        </div>
      `;

      const button = card.querySelector("button");
      button.disabled = this.state.selectedCase && !isSelected;
      // Store product id on card for reference in click handler
      card.dataset.productId = product.id;
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        // Check current state at click time, not bind time
        const currentlySelected =
          this.state.selectedCase && this.state.selectedCase.id === product.id;
        if (currentlySelected) {
          this.state.selectedCase = null;
        } else {
          this.state.selectedCase = {
            ...product,
            quantity: 1,
            productGender: this.state.gender,
          };
          // Auto-proceed to next step after selection
          setTimeout(() => {
            if (this.state.selectedCase) {
              this.state.step = 3;
              this.render();
            }
          }, 300);
        }
        this.state.total = this.calculateTotal();
        this.render();
      });

      this.caseProducts.appendChild(card);
    });
  }

  renderScents() {
    if (!this.scentProducts) return;

    this.scentProducts.innerHTML = "";
    const scents = this.products.scents[this.state.gender] || [];

    if (scents.length === 0) {
      this.scentProducts.innerHTML = `<p>${
        this.products.uiText?.noScentsMessage || "No scents available."
      }</p>`;
      return;
    }

    const scentsCount = this.getTotalScentsCount();
    if (
      scentsCount === this.state.scentLimit &&
      !this.state.additionalSlotEnabled &&
      !this.hasShownAdditionalPopup
    ) {
      this.hasShownAdditionalPopup = true;
      setTimeout(() => {
        this.showAdditionalSlotPopup();
      }, 100);
    }

    // Check if we need to show 5th scent popup
    if (
      scentsCount === 4 &&
      this.state.additionalSlotEnabled &&
      !this.state.fifthSlotEnabled &&
      !this.hasShownFifthPopup
    ) {
      this.hasShownFifthPopup = true;
      setTimeout(() => {
        this.showFifthScentPopup();
      }, 100);
    }

    const currentLimit = this.getCurrentScentLimit();

    scents.forEach((product) => {
      const selectedScent = this.state.selectedScents.find(
        (s) => s.id === product.id,
      );

      const hasOriginalPrice =
        product.originalPrice && product.originalPrice > product.price;
      const savings = hasOriginalPrice
        ? (product.originalPrice - product.price).toFixed(2)
        : null;

      const isDisabled =
        !selectedScent && this.getTotalScentsCount() >= currentLimit;

      const card = document.createElement("div");
      card.className = `product-card ${selectedScent ? "selected" : ""} ${
        isDisabled ? "disabled" : ""
      } ${
        product.Stock > 10
          ? "in_stock"
          : product.Stock > 0
            ? "low_stock"
            : product.Stock == "In stock"
              ? ""
              : "out_of_stock"
      }`;

      card.innerHTML = `
        <img src="${product.image || "placeholder.jpg"}" alt="${
          product.name || "Unknown Product"
        }" loading="eager">
        <div class="card-info">
          <p class="name">${product.name || "Unknown Product"}</p>
          <p class="stock">Only ${product.Stock} left in Stock</p>
          <p class="no_stock">Out of Stock</p>
          <div class="desc-container">
            <p class="desc">${
              product?.description
                ? product.description.split(" ").slice(0, 10).join(" ") + "..."
                : ""
            }<span class="read_more">Readmore</span></p>
             <p class="desc read-more-desc">${
               product?.description
             } <span class="read_less">Read less</span></p>
          </div>
          <div class="btn_wrapper">
          ${
            selectedScent
              ? `<div class="quantity-controls">
              <button class="decrease">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3334 8.37695H2.66675" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <span>${selectedScent.quantity}</span>
              <button class="increase">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00008 3.04395V13.7106M13.3334 8.37728L2.66675 8.37728" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>`
              : `<button>${
                  this.products.uiText?.addToBoxButton || "ADD TO BOX"
                }</button>`
          }
          </div>
        </div>
      `;

      if (!selectedScent) {
        const button = card.querySelector("button");
        button.disabled = isDisabled;
        button.addEventListener("click", (e) => {
          e.stopPropagation();

          if (this.getTotalScentsCount() >= currentLimit) {
            alert(
              this.products.uiText?.scentLimitMessage ||
                "You've reached the scent limit. Remove a scent to add another.",
            );
            return;
          }

          this.state.selectedScents.push({
            ...product,
            quantity: 1,
            productGender: this.state.gender,
          });

          this.state.total = this.calculateTotal();
          this.render();

          // scroll to checkout
          if (this.getTotalScentsCount() === currentLimit) {
            setTimeout(() => this.scrollToCheckout(), 300);
          }
        });
      } else {
        card.querySelector(".decrease").addEventListener("click", (e) => {
          e.stopPropagation();
          selectedScent.quantity--;

          if (selectedScent.quantity === 0) {
            this.state.selectedScents = this.state.selectedScents.filter(
              (s) => s.id !== product.id,
            );

            // the additional slot, show popup again
            if (
              this.state.additionalSlotEnabled &&
              this.getTotalScentsCount() < this.state.scentLimit
            ) {
              this.hasShownAdditionalPopup = false;
              this.state.additionalSlotEnabled = false;
            }

            // Reset fifth slot if below 4 scents
            if (this.state.fifthSlotEnabled && this.getTotalScentsCount() < 4) {
              this.hasShownFifthPopup = false;
              this.state.fifthSlotEnabled = false;
            }
          }

          this.state.total = this.calculateTotal();
          this.render();
        });

        card.querySelector(".increase").addEventListener("click", (e) => {
          e.stopPropagation();

          const currentCount = this.getTotalScentsCount();
          const currentLimit = this.getCurrentScentLimit();

          if (currentCount >= currentLimit) {
            alert(
              this.products.uiText?.scentLimitMessage ||
                "You've reached the scent limit. Remove a scent to add another.",
            );
            return;
          }

          selectedScent.quantity++;
          this.state.total = this.calculateTotal();
          this.render();

          // scroll to checkout
          if (this.getTotalScentsCount() === currentLimit) {
            setTimeout(() => this.scrollToCheckout(), 300);
          }
        });
      }

      this.scentProducts.appendChild(card);
    });
  }

  showAdditionalSlotPopup() {
    if (this.editMode) return; // no upsell popups when editing an existing subscription
    const additionalProduct = this.products.additionalProduct;
    if (!additionalProduct) return;

    const existingModal = document.querySelector(".discount-modal");
    if (existingModal) {
      document.body.removeChild(existingModal);
    }

    const modal = document.createElement("div");
    modal.className = "discount-modal";
    modal.innerHTML = `
      <div class="discount-modal-content">
        <div class="image-container">
          <img src="${
            additionalProduct.boxImage ||
            "https://cdn.shopify.com/s/files/1/0887/7903/0874/files/perfume_1.png?v=1743622998"
          }" alt="${additionalProduct.title || "Special Offer"}" loading="eager">
        </div>
        <div class="premium-product">
          <h3>${additionalProduct.title || "Special Offer"}</h3>
          <p>${additionalProduct.subtitle || ""}</p>
          <p>${
            additionalProduct.description ||
            "Add a 4th scent for just €2.99 and enjoy extra variety."
          }</p>
        </div>
        <div class="discount-modal-actions">
          <button class="add-with-discount btn">${
            additionalProduct.addButtonText || "Add for €2.99"
          }</button>
          <button class="close-modal">${
            additionalProduct.closeButtonText || "No Thanks"
          }</button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector(".add-with-discount").addEventListener("click", () => {
      // Enable the additional slot
      this.state.additionalSlotEnabled = true;
      this.render();
      document.body.removeChild(modal);

      setTimeout(() => this.scrollToScentSelection(), 300);
    });

    modal.querySelector(".close-modal").addEventListener("click", () => {
      this.state.additionalSlotEnabled = false;
      this.state.total = this.calculateTotal();
      document.body.removeChild(modal);
      setTimeout(() => this.scrollToCheckout(), 300);
    });
  }

  showFifthScentPopup() {
    if (this.editMode) return; // no upsell popups when editing an existing subscription
    const existingModal = document.querySelector(".discount-modal");
    if (existingModal) {
      document.body.removeChild(existingModal);
    }

    const modal = document.createElement("div");
    modal.className = "discount-modal";
    modal.innerHTML = `
      <div class="discount-modal-content">
        <div class="image-container">
          <img src="https://cdn.shopify.com/s/files/1/0887/7903/0874/files/perfume_1.png?v=1743622998" alt="5th Scent Offer" loading="eager">
        </div>
        <div class="premium-product">
          <h3>Would you like to add a Free scent and join our subscription today</h3>
          <p>Your box fits 4 fragrances, but we’ve made room for one more!</p>
          <p>save 25% + Unlock Free Shipping + a Free Scent</p>
        </div>
        <div class="discount-modal-actions">
          <button class="add-fifth-scent btn">Add for free</button>
          <button class="close-modal">No Thanks</button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector(".add-fifth-scent").addEventListener("click", () => {
      // Enable the fifth slot
      this.state.fifthSlotEnabled = true;
      this.render();
      document.body.removeChild(modal);

      setTimeout(() => this.scrollToScentSelection(), 300);
    });

    modal.querySelector(".close-modal").addEventListener("click", () => {
      this.state.fifthSlotEnabled = false;
      this.state.total = this.calculateTotal();
      document.body.removeChild(modal);
      setTimeout(() => this.scrollToCheckout(), 300);
    });
  }

  scrollToScentSelection() {
    const scentProductsSection = document.getElementById("scent-products");
    if (scentProductsSection) {
      scentProductsSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  scrollToCheckout() {
    const buildABoxContainer = document.querySelector(".build-a-box");
    if (buildABoxContainer) {
      const containerRect = buildABoxContainer.getBoundingClientRect();
      const containerBottom = containerRect.bottom + window.pageYOffset;
      window.scrollTo({
        top: containerBottom - window.innerHeight + 100,
        behavior: "smooth",
      });
    }
  }

  truncateText(text, maxLength = 80) {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  }

  renderSummary() {
    if (
      !this.state.selectedBox &&
      !this.state.selectedCase &&
      this.state.selectedScents.length === 0
    ) {
      this.summaryContent.innerHTML = `
        <svg class="group-2" xmlns="http://www.w3.org/2000/svg" width="123" height="108" viewBox="0 0 123 108" fill="none">
          <path d="M20.4473 38.895L64.6579 13.6318L102.502 35.2571C104.436 36.362 106.044 37.9587 107.162 39.8854C108.28 41.812 108.869 44.0001 108.868 46.2276V75.7729C108.869 78.0005 108.28 80.1885 107.162 82.1152C106.044 84.0418 104.436 85.6385 102.502 86.7434L70.9231 104.788C69.0149 105.878 66.8554 106.451 64.6579 106.451C62.4603 106.451 60.3008 105.878 58.3926 104.788L26.8136 86.7434C24.8794 85.6385 23.2717 84.0418 22.1537 82.1152C21.0356 80.1885 20.4469 78.0005 20.4473 75.7729V58.076" stroke="#939393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M58.6705 60.9369C60.5107 61.9276 62.568 62.4461 64.6579 62.4461C66.7478 62.4461 68.8051 61.9276 70.6453 60.9369L105.711 42.0527M64.6579 64.158V105.211" stroke="#939393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4474 38.8947L64.6579 64.1579L45.7105 70.4737L1.5 45.2105L20.4474 38.8947ZM64.6579 13.6316L108.868 38.8947L121.5 26.2632L77.2895 1L64.6579 13.6316Z" stroke="#939393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="summary-content-container">
          <p class="p">${
            this.products.uiText?.emptyBoxDescription ||
            "Your box is currently empty, let's select the box color you like first."
          }</p>
        </div>
      `;
      return;
    }

    let html = "";
    let sectionHtml = "";

    // Box section (step 1)
    if (this.state.selectedBox) {
      sectionHtml = `
        <div class="summary-section">
          <h4>${this.products.uiText?.selectedBoxTitle || "Selected Box"}</h4>
          <div class="item">
            <img src="${
              this.state.selectedBox.image || "placeholder.jpg"
            }" alt="${this.state.selectedBox.name}" loading="eager">
            <div class="details">
              ${
                this.state.selectedBox.description
                  ? `<p class="description" title="${
                      this.state.selectedBox.description
                    }">${this.truncateText(
                      this.state.selectedBox.description,
                    )}</p>`
                  : ""
              }
            </div>
            ${
              this.state.step === 1
                ? `<button class="remove-item" data-type="box">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#636363" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 6h18" />
                  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14" />
                </svg>
              </button>`
                : ""
            }
          </div>
        </div>
      `;
      html += sectionHtml;
    }

    // Case section (step 2)
    if (this.state.selectedCase) {
      sectionHtml = `
        <div class="summary-section">
          <h4>${this.products.uiText?.selectedCaseTitle || "Selected Case"}</h4>
          <div class="item">
            <img src="${
              this.state.selectedCase.image || "placeholder.jpg"
            }" alt="${this.state.selectedCase.name}" loading="eager">
            <div class="details">
              ${
                this.state.selectedCase.description
                  ? `<p class="description" title="${
                      this.state.selectedCase.description
                    }">${this.truncateText(
                      this.state.selectedCase.description,
                    )}</p>`
                  : ""
              }
            </div>
            ${
              this.state.step === 2
                ? `<button class="remove-item" data-type="case">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#636363" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 6h18" />
                  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14" />
                </svg>
              </button>`
                : ""
            }
          </div>
        </div>
      `;
      html += sectionHtml;
    }

    // Scents section (step 3)
    if (this.state.step === 3) {
      const currentLimit = this.getCurrentScentLimit();

      sectionHtml = `
        <div class="summary-section">
          <h4>${
            this.products.uiText?.selectedScentsTitle || "Selected Scents"
          } (${this.getTotalScentsCount()}/${currentLimit})</h4>
      `;

      if (this.state.selectedScents.length === 0) {
        sectionHtml += `
          <div class="empty-scents-message">
            <p>${
              this.products.uiText?.emptyScentSelection ||
              "Please select scents to complete your box."
            }</p>
          </div>
        `;
      } else {
        this.state.selectedScents.forEach((scent) => {
          sectionHtml += `
            <div class="item">
              <img src="${scent.image || "placeholder.jpg"}" alt="${
                scent.name
              }" loading="eager">
              <div class="details">
                <p>${scent.name} <span class="gender-tag">(${
                  scent.productGender || this.state.gender
                })</span> X ${scent.quantity}</p>
                ${
                  scent.description
                    ? `<p class="description" title="${
                        scent.description
                      }">${this.truncateText(scent.description)}</p>`
                    : ""
                }
              </div>
              <button class="remove-item" data-type="scent" data-id="${
                scent.id
              }">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#636363" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 6h18" />
                  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M5 6l1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14" />
                </svg>
              </button>
            </div>
          `;
        });
      }
      sectionHtml += `</div>`;
      html += sectionHtml;

      // Show the additional slot badge if applicable
      // if (this.state.additionalSlotEnabled) {
      //   html += `
      //     <div class="additional-slot-badge">
      //       <span class="badge">4th Fragrance Added! €2.99</span>
      //     </div>
      //   `;
      // }

      // Only show total in step 3 and if the required number of scents are selected
      const scentCount = this.getTotalScentsCount();
      const requiredCount = this.state.scentLimit;
      if (scentCount >= requiredCount) {
        if (this.editMode) {
          // EDIT MODE: customer is already subscribed — no pricing / purchase
          // options. Just a friendly note that this updates their next box.
          html += `
            <div class="ps-edit-note" style="margin-top:18px;padding:16px 18px;border:1px solid #0000001a;border-radius:6px;background:#f7faf6;">
              <div style="display:flex;align-items:center;gap:10px;">
                <span style="flex:0 0 auto;width:26px;height:26px;border-radius:50%;background:#54c63a;color:#fff;display:flex;align-items:center;justify-content:center;font-size:15px;">✓</span>
                <div style="font-size:14px;line-height:1.4;color:#242424;">
                  <strong>You're editing your subscription box.</strong><br>
                  These changes will apply to your next delivery. Your plan, price and delivery schedule stay exactly the same.
                </div>
              </div>
            </div>
          `;
        } else {
        html += `
          <div class="total">
            <span>${this.products.uiText?.totalLabel || "Total"}</span>
            <span>€${this.state.total.toFixed(2)}</span>
          </div>

          <div class="pricing-wrapper">
            <!-- One-time card -->
            <div class="pricing-card ${this.state.purchaseType === "onetime" ? "selected" : ""}${this.getTotalScentsCount() >= 5 ? "disabled" : ""}" id="card-onetime">
              <div class="card-header">
                <div class="radio-btn"><div class="dot"></div></div>
                <div class="card-title-group">
                  <span class="card-title">One-time</span>
                  <div class="price-row">
                    <span class="price-current">€39,99</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Subscribe & Save card -->
            <div class="pricing-card ${this.state.purchaseType === "subscribe" ? "selected" : ""}" id="card-subscribe">
              <span class="badge">Best Value</span>

              <div class="card-header">
                <div class="radio-btn"><div class="dot"></div></div>
                <div class="card-title-group">
                  <span class="card-title">Subscribe &amp; save</span>
                  <div class="price-row">
                    <span class="price-original">€39,99</span>
                    <span class="price-current">€29,99</span>
                  </div>
                </div>
              </div>

              <ul class="feature-list">
                <li>
                  <span class="check-icon">
                    <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="2,6 5,9 10,3"/>
                    </svg>
                  </span>
                  5 designer inspired scents
                </li>
                <li>
                  <span class="check-icon">
                    <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="2,6 5,9 10,3"/>
                    </svg>
                  </span>
                  Customise before renewal
                </li>
                <li>
                  <span class="check-icon">
                    <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="2,6 5,9 10,3"/>
                    </svg>
                  </span>
                  Skip or cancel anytime
                </li>
              </ul>

              <a class="learn-more" href="#">Learn more</a>

              <div class="delivery-section">
                <div class="delivery-label">Deliver every:</div>
                <div class="delivery-options">
                  <button class="delivery-btn active" onclick="selectDelivery(this, event)">2 months <span>save 25%</span></button>
                </div>
              </div>
            </div>
          </div>
        `;
        }
      }
    }

    this.summaryContent.innerHTML = html;

    const subscribeCard = this.summaryContent.querySelector("#card-subscribe");
    const onetimeCard = this.summaryContent.querySelector("#card-onetime");

    // if (subscribeCard && subscribeCard.classList.contains('selected')) {
    //   this.state.selling_plan_id = "692079100250";
    // }else{
    //   this.state.selling_plan_id = null;
    // }

    if (subscribeCard) {
      subscribeCard.addEventListener("click", () => {
        this.state.purchaseType = "subscribe";
        this.state.selling_plan_id = "692079100250";
        this.renderSummary();
      });
    }

    if (onetimeCard) {
      onetimeCard.addEventListener("click", () => {
        this.state.purchaseType = "onetime";
        this.state.selling_plan_id = null;
        this.renderSummary();
      });
    }

    this.summaryContent.querySelectorAll(".remove-item").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const type = e.currentTarget.dataset.type;
        const id = e.currentTarget.dataset.id
          ? parseInt(e.currentTarget.dataset.id)
          : null;

        if (type === "box") {
          this.state.selectedBox = null;
        } else if (type === "case") {
          this.state.selectedCase = null;
        } else if (type === "scent" && id) {
          this.state.selectedScents = this.state.selectedScents.filter(
            (s) => s.id !== id,
          );

          if (
            this.state.additionalSlotEnabled &&
            this.getTotalScentsCount() < this.state.scentLimit
          ) {
            this.state.additionalSlotEnabled = false;
            this.hasShownAdditionalPopup = false;
          }

          // Reset fifth slot if below 4 scents
          if (this.state.fifthSlotEnabled && this.getTotalScentsCount() < 4) {
            this.state.fifthSlotEnabled = false;
            this.hasShownFifthPopup = false;
          }
        }

        this.state.total = this.calculateTotal();
        this.render();
      });
    });
  }

  addToCart() {
    if (
      !this.state.selectedBox ||
      !this.state.selectedCase ||
      this.state.selectedScents.length === 0
    ) {
      alert(
        this.products.uiText?.addToCartError ||
          "Please select a box, case, and at least one scent before adding to cart.",
      );
      return;
    }

    // Check if have enough scents
    const currentLimit = this.getCurrentScentLimit();
    const minRequired = this.state.scentLimit;
    const scentCount = this.getTotalScentsCount();

    if (scentCount < minRequired) {
      alert(`Please select at least ${minRequired} scents to continue.`);
      return;
    }

    if (scentCount > currentLimit) {
      alert(`You cannot select more than ${currentLimit} scents.`);
      return;
    }

    this.nextStepBtn.disabled = true;
    this.nextStepBtn.textContent =
      this.products.uiText?.addingToCartText || "ADDING TO CART...";

    // Generate a unique ID for this box set
    const timestamp = new Date().getTime();
    const boxSetId = `perfume-box-${timestamp}`;

    // Determine which product to add to cart (with or without additional)
    const currentScentCount = this.getTotalScentsCount();
    const productToAdd =
      this.state.additionalSlotEnabled && currentScentCount >= 4
        ? this.products.product_with_additional
        : this.products.product_without_additional;

    // Create line item properties to store selection details
    const properties = {
      // "box set id": boxSetId,
      // "box id": this.state.selectedBox.id,
      "box name": this.state.selectedBox.name,
      // "case id": this.state.selectedCase.id,
      "case name": this.state.selectedCase.name,
      // if (this.state.selling_plan_id) {
      //   properties["Subscription Plan ID"] = this.state.selling_plan_id;
      // }
    };
    // const properties = {
    //   _box_set_id: boxSetId,
    //   _box_id: this.state.selectedBox.id,
    //   box_name: this.state.selectedBox.name,
    //   _case_id: this.state.selectedCase.id,
    //   case_name: this.state.selectedCase.name,
    // };

    // Add each scent to the properties
    this.state.selectedScents.forEach((scent, index) => {
      properties[`Scent ${index + 1}`] = `${scent.name} × ${scent.quantity}`;
    });
    // this.state.selectedScents.forEach((scent, index) => {
    //   properties[`_scent_${index + 1}_id`] = scent.id;
    //   properties[`scent_${index + 1}_name`] = scent.name;
    //   properties[`scent_${index + 1}_quantity`] = scent.quantity;
    // });

    // Add the indicator for whether an additional slot was used
    properties["Extra Slot Added"] = this.state.additionalSlotEnabled
      ? "Yes"
      : "No";

    // Add the indicator for whether a 5th slot was used
    properties["5th Slot Added"] = this.state.fifthSlotEnabled ? "Yes" : "No";
    // properties["_additional_slot_enabled"] = this.state.additionalSlotEnabled;

    // if (this.state.selling_plan_id != null) {
    //   properties["Subscription Plan"] = "2 month subscription with 25% discount";
    //   // properties["Subscription Plan"] = this.state.selling_plan_id ? "2 month subscription with 25% discount" : "";
    // }
    const item = {
      id: productToAdd.id,
      quantity: 1,
      properties: properties,
      selling_plan: this.state.selling_plan_id || undefined,
    };

    // Add to cart
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: [item] }),
      keepalive: true,
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => Promise.reject(data));
        }
        return response.json();
      })
      .then((data) => {
        window.location.href = "/checkout";
      })
      .catch((error) => {
        console.error("Error adding items to cart:", error);
        if (error.description) {
          alert(`Error: ${error.description}`);
        } else {
          alert(
            this.products.uiText?.cartErrorMessage ||
              "There was an error adding items to your cart. Please try again.",
          );
        }
      })
      .finally(() => {
        this.nextStepBtn.disabled = false;
        this.nextStepBtn.textContent =
          this.products.uiText?.checkoutButton || "CHECK OUT";
      });
  }
}

// Initialize
document.addEventListener("DOMContentLoaded", () => {
  requestAnimationFrame(() => {
    new BuildABox();
  });
});